
import React, { useState, useEffect } from 'react';
import { ShieldIcon, CheckCircleIcon, XIcon } from './Icons';
import { requestPushPermissionAndSubscribe } from '../services/pushService';

const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('astro_cookie_consent');
        if (!consent) {
            // Petit délai pour l'animation d'entrée
            setTimeout(() => setIsVisible(true), 1500);
        } else if (consent === 'true') {
            // Déjà accepté — vérifier si le Push est souscrit, sinon re-tenter silencieusement
            const pushEnabled = localStorage.getItem('astro_push_enabled');
            if (!pushEnabled) {
                setTimeout(() => {
                    try {
                        const clientRaw = localStorage.getItem('astro_current_client');
                        const client = clientRaw ? JSON.parse(clientRaw) : null;
                        if (client && client.id) {
                            requestPushPermissionAndSubscribe(client);
                        }
                    } catch (e) {
                        console.warn("[CookieConsent] Auto push retry error:", e);
                    }
                }, 3000);
            }
        }
    }, []);

    const handleAccept = async () => {
        localStorage.setItem('astro_cookie_consent', 'true');
        window.dispatchEvent(new Event('astro_cookie_consent_updated'));
        setIsVisible(false);

        // Demande et enregistrement automatique des notifications Web Push sur le smartphone / PC
        // Petit délai pour laisser le temps au navigateur de traiter le geste utilisateur
        setTimeout(async () => {
            try {
                const clientRaw = localStorage.getItem('astro_current_client');
                const client = clientRaw ? JSON.parse(clientRaw) : null;
                console.log('[CookieConsent] Client pour Push:', client ? client.name + ' (id:' + client.id + ')' : 'NON CONNECTÉ');
                const result = await requestPushPermissionAndSubscribe(client || undefined);
                console.log('[CookieConsent] Push subscription résultat:', result);
            } catch (e) {
                console.warn("Push subscription trigger error:", e);
            }
        }, 500);
    };

    const handleDecline = () => {
        localStorage.setItem('astro_cookie_consent', 'false');
        window.dispatchEvent(new Event('astro_cookie_consent_updated'));
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-16 sm:bottom-20 xl:bottom-6 left-0 w-full z-[999] px-3 sm:px-4 md:px-6 animate-slide-up pointer-events-none" style={{ touchAction: 'pan-y' }}>
            <div className="max-w-4xl mx-auto bg-mystic-900/98 backdrop-blur-2xl border border-gold-500/40 rounded-2xl shadow-[0_0_50px_rgba(0,0,0,0.85)] p-4 sm:p-6 flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6 pointer-events-auto relative">
                
                <div className="flex items-start gap-4">
                    <div className="bg-gold-500/20 p-3 rounded-full hidden md:block shrink-0">
                        <ShieldIcon className="w-6 h-6 text-gold-400" />
                    </div>
                    <div>
                        <h4 className="text-white font-serif font-bold text-base sm:text-lg mb-1 flex items-center gap-2">
                             Respect de votre vie privée
                        </h4>
                        <p className="text-gray-300 text-xs sm:text-sm leading-relaxed max-w-2xl">
                            Nous utilisons des cookies pour sauvegarder votre profil, vos tirages et assurer le bon fonctionnement du chat. Vos données restent strictement confidentielles et ne sont jamais cédées.
                        </p>
                    </div>
                </div>

                <div className="flex flex-row gap-3 w-full md:w-auto shrink-0">
                    <button 
                        onClick={handleDecline}
                        className="flex-1 md:flex-none px-4 py-3 rounded-xl border border-white/15 text-gray-300 hover:text-white hover:bg-white/10 text-xs sm:text-sm font-bold transition-colors cursor-pointer text-center"
                    >
                        Refuser
                    </button>
                    <button 
                        onClick={handleAccept}
                        className="flex-1 md:flex-none px-6 py-3 rounded-xl bg-gradient-to-r from-gold-500 via-amber-400 to-gold-500 hover:from-gold-400 hover:to-amber-300 text-black font-black text-xs sm:text-sm shadow-[0_0_25px_rgba(251,191,36,0.4)] transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-2 cursor-pointer text-center"
                    >
                        <CheckCircleIcon className="w-4 h-4" /> Accepter
                    </button>
                </div>

                <button 
                    onClick={handleDecline} 
                    className="absolute top-2 right-2 md:hidden text-gray-400 hover:text-white p-2 cursor-pointer"
                    aria-label="Fermer"
                >
                    <XIcon className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
